export default __webpack_public_path__ + "static/media/gallery-14.1601087b.jpg";